/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2015, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'../../../app/util/ErrorUtils',
	'underscore',
	'../util/InstrumentationUtil'
], function (BaseClass, Utils, _, InstrumentationUtil) {

	var ActionHandler = BaseClass.extend({

		/**
		 * Public API to indicate if the Action should be shown
		 */
		isItemVisible: function (options) {
			return this.canExecute(options);
		},

		/**
		 * Public API to indicate if the Action can be executed.
		 */
		canExecute: function (options) {
			var selection = options.target && options.target.activeObject && options.target.activeObject.aSelectedContext;
			var isSelectionAllowed = false;
			if (selection.length === 1) {
				isSelectionAllowed = this._isSelectionValid(options, true);
			}
			return isSelectionAllowed && Utils.hasCapability(options.glassContext);
		},

		/**
		 * Public API to perform the action.
		 */
		doAction: function (context) {
			return this._openDashboardView(context);
		},

		/**
		 * Handle the open dashboard action
		 */
		onSelectItem: function (context) {
			return this._openDashboardView(context);
		},

		_openDashboardView: function (context) {
			var id = context.target.activeObject.aSelectedContext[0].id;
			return this._getTargetPerspective(id, context).then((perspective) => {
				InstrumentationUtil.track(context.glassContext, 'viewed', {
					objectType: perspective,
					object: id,
					type: 'Read Object'
				});
				return context.glassContext.appController.openAppView(perspective, {
					id: id,
					content: {
						boardId: id,
						isAuthoringMode: false,

						// build a complete urlMap context for dashboard/story
						objRef: id
					}
				});
			});
		},

		_getTargetPerspective: function () {
			return Promise.resolve('dashboard');

		},

		_hasValidTags: function(item) {
			const tags = item.tags || [];
			return tags.includes('dashboard');
		},

		_isSelectionValid: function (options, defaultValue) {
			const selection = options.target && options.target.activeObject && options.target.activeObject.aSelectedContext;
			if (selection) {
				for (let item of selection) {
					if( !this._hasValidTags(item)){
						return false;
					}

					// The item must be either module or uploaded File
					const aType = ['exploration', 'page_asset'];
					if (_.intersection([item.type], aType).length < 1) {
						return false;
					}

					// The item must have read permission
					const aPerm = ['read', 'execute'];
					if (_.intersection(item.permissions, aPerm).length < aPerm.length) {
						return false;
					}

					// The item must not be disabled
					if (item.disabled && item.disabled.toString().toLowerCase() === 'true') {
						return false;
					}
				}
				return true;
			}
			return defaultValue || false;
		}

	});
	return ActionHandler;
});
